import React from 'react'
import Home from './components/Home'
import { Route, Routes } from 'react-router'
import Marketing from './components/Marketing'
import WebDevelopment from './components/WebDevelopment'
import UXUi from './components/UXUi'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import WhatsappIcon from './components/WhatsappIcon'
import Android from './components/Android'
import About from './components/About'
import OurWork from './components/OurWork'
import ContactUS from './components/ContactUS'

const App = () => {
  return (
    <>
    <Navbar/>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/marketing' element={<Marketing/>}/>
        <Route path='/android' element={<Android/>}/>
        <Route path='/webdevelopment' element={<WebDevelopment/>}/>
        <Route path='/uxui' element={<UXUi/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/work' element={<OurWork/>}/>
        <Route path='/contact' element={<ContactUS/>}/>
    </Routes>
    <WhatsappIcon/>
    <Footer/>
    </>
  )
}

export default App
